// src/App.tsx
import React, { useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from './theme/ThemeProvider';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import AppRoutes from './routes';
import { RESET_STORE, store } from '../src/store';
import { initializeTokenService } from './services/initializeTokenService';
import ErrorBoundary from './components/common/ErrorBoundary';
import { subscribeToSessionExpiry } from './services/sessionService';
import { tokenService } from './services/tokenService';
 
function App() {
  useEffect(() => {
    const unsubscribe = subscribeToSessionExpiry(() => {
      store.dispatch({ type: RESET_STORE });
    });

    initializeTokenService();

    return () => {
      unsubscribe();
      tokenService.stopTokenRefreshMonitor();
    };
  }, []);

  return (
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <ThemeProvider>
          <AuthProvider>
            <ModalProvider>
              <AppRoutes />
            </ModalProvider>
          </AuthProvider>
        </ThemeProvider>
      </ReduxProvider>
    </ErrorBoundary>
  );
}

export default App;
